import React from "react";
import {BarChart, MapChart} from "../chart";
import {Filters} from "./shared/Filters/Filters";
import {useFetchData} from "./shared/useFetchData";

const WycinkaDrzewDashboard = () => {
    const [initData, data, filters, activeFilters, setFilters] = useFetchData('WYCINKA_DRZEW', true);

    return (
        <div className="container">
            <div className="title-container">
                <h2 className={'title'}>Pozwolenia na wycinkę drzew i krzewów</h2>
            </div>
            <Filters data={filters} setFilters={setFilters}/>
            <div className="visualization-container">
                <BarChart data={data} groupBy={'decisionDate'}
                          mainKey={'organization'}
                          value={'clearingQuantity'}
                          title={'liczba drzew/krzewów do wycinki'}
                          noSort/>
                <BarChart data={data} groupBy={'decisionDate'}
                          mainKey={'organization'}
                          value={'plantQuantity'}
                          title={'liczba nasadzeń'}
                          noSort/>
            </div>
            <div className="visualization-container">
                <MapChart data={initData}
                          filters={filters}
                          activeFilters={activeFilters}
                          groupBy={'organization'}
                          value={'clearingQuantity'}
                          featureClick={setFilters}/>
                <BarChart data={data}
                          groupBy={'organization'}
                          value={'clearingQuantity'}
                          layout={'horizontal'}
                          title={'Gmina'}/>
            </div>
        </div>
    )
}

export {WycinkaDrzewDashboard as default}